import { AULA_PROFILE_MENU_BG_COLOUR } from '@ublend-npm/aulaui-core';

export const createStyles = (
  theme: any,
  isDark: boolean,
  dropdownMaxHeight: number
) => ({
  filterButton: {
    bgcolor: 'background.paper',
    borderColor: 'grey.400',
    borderRadius: 1,
    color: 'text.secondary',
    fontSize: '1rem',
    fontWeight: 400,
    height: '40px',
    justifyContent: 'space-between',
    minWidth: 0,
    px: 1.5,
    textTransform: 'none',
    width: '100%',
    '& .MuiButton-endIcon': { flexShrink: 0 },
    '&:hover': {
      bgcolor: 'background.paper',
      borderColor: 'primary.main',
    },
  },
  selectedLabel: { flex: 1, minWidth: 0, textAlign: 'left' },
  menuPaper: {
    '& .group-filter-option': {
      paddingBottom: '2px',
      paddingLeft: '8px',
      paddingRight: '0px',
      paddingTop: '2px',
    },
    backgroundColor: isDark ? AULA_PROFILE_MENU_BG_COLOUR : 'background.paper',
    borderRadius: '12px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: dropdownMaxHeight,
    mt: 0.5,
    overflow: 'hidden',
    px: 1,
    py: 1.5,
    width: '240px',
  },
  menuPaperStyle: {
    backgroundColor: isDark
      ? AULA_PROFILE_MENU_BG_COLOUR
      : theme?.palette?.background?.paper,
    // MUI adds an elevation overlay in dark mode; remove it so the requested
    // Aula profile-menu surface is rendered without a lighter tint.
    backgroundImage: 'none',
  },
  scrollableContent: {
    flex: 1,
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  groupList: { minWidth: 0 },
  groupSet: { minWidth: 0, py: '6px' },
  groupSetText: {
    color: isDark ? '#FFFFFFDE' : '#000000DE',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
  },
  groupOptionLabel: {
    boxSizing: 'border-box',
    minWidth: 0,
    '& .MuiFormControlLabel-root': { marginRight: 0 },
    pl: '3px',
    width: '100%',
  },
  radio: {
    '& .MuiSvgIcon-root': {
      height: '20px',
      width: '20px',
    },
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: '38px',
    justifyContent: 'center',
    p: 0,
    width: '35.24px',
  },
  groupOptionText: { color: 'text.secondary', flex: 1, minWidth: 0 },
  manageGroupsContainer: { py: 1 },
  manageGroupsButton: {
    '& .MuiListItemIcon-root': {
      color: 'text.secondary',
      height: '30px',
      minWidth: '30px',
      width: '30px',
    },
    '& .MuiListItemText-root': {
      marginLeft: '4px',
    },
    '& .MuiMenuItem-root': {
      boxSizing: 'border-box',
      height: '42px',
      minHeight: '42px',
      py: '8px',
      px: '4px',
    },
    backgroundColor: theme?.palette?.background?.default,
    borderRadius: '8px',
    boxSizing: 'border-box',
    height: '42px',
    overflow: 'hidden',
    width: '100%',
  },
  footer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    gap: '8px',
    justifyContent: 'flex-end',
    pb: 0,
    pt: 1,
    width: '100%',
  },
  manageGroupsLabel: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  manageGroupsArrow: {
    color: 'text.secondary',
    flexShrink: 0,
  },
  manageGroupsIconWrapper: {
    alignItems: 'center',
    display: 'flex',
    height: '30px',
    justifyContent: 'center',
    width: '30px',
  },
  manageText: {
    color: 'text.secondary',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
  },
});
